var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollegeSuccess = function SvgCollegeSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3EB670",
    d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M21.055 20.594a3.64 3.64 0 0 1-2.11 0l-7.851-2.422q-.39.546-.469 1.523.313.156.469.43.156.273.156.625t-.176.645a1.24 1.24 0 0 1-.449.449l.625 4.804a.4.4 0 0 1-.078.254q-.078.098-.235.098H9.062q-.156 0-.234-.098a.4.4 0 0 1-.078-.254l.625-4.804a1.24 1.24 0 0 1-.45-.45 1.23 1.23 0 0 1-.175-.644q0-.352.176-.645t.449-.449q.078-1.133.508-1.875l-1.719-.508a.83.83 0 0 1-.586-.507 1.02 1.02 0 0 1 0-.782q.156-.39.586-.507l10.781-3.32a3.64 3.64 0 0 1 2.11 0l10.78 3.32a.83.83 0 0 1 .587.507q.156.39 0 .782-.156.39-.586.507zm.39 1.21 5.86-1.835.507 3.281q0 .665-1.054 1.25-1.055.586-2.852.918T20 25.75t-3.906-.332-2.852-.918-1.055-1.25l.508-3.281 5.899 1.836a5.16 5.16 0 0 0 2.812 0z"
  }))));
};
export default SvgCollegeSuccess;